import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useSearchParams } from 'react-router'

export default function Page() {
  let [searchParams] = useSearchParams()

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-6">
          <Card>
            <CardHeader>
              <CardTitle className="text-2xl">抱歉，出现了错误。</CardTitle>
            </CardHeader>
            <CardContent>
              {searchParams?.get('error') ? (
                <p className="text-sm text-muted-foreground">
                  错误代码： {searchParams?.get('error')}
                </p>
              ) : (
                <p className="text-sm text-muted-foreground">发生了未指定的错误。</p>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
